import {afterEnhance, aureliaEnhance, preEnhance} from "./bootstrap/app-enhancer";
import {EventAggregator} from "aurelia-event-aggregator";
import {addStartHook} from "./bootstrap/app-hooks";
import {AuthService} from "./services/auth-service";
import {instance} from "./tools/di";
import {defaultGroupId, GroupService} from "./services/group/group-service";
import {CurrentGroup} from "./services/group/current-group";
import {UserDetails} from "./services/user-service";
import {BillingService} from "./services/billing-service";
import {PLATFORM, TaskQueue} from "aurelia-framework";
import {Event} from "./broadcast/event";

PLATFORM.global.AureliaApi = {
  defaultGroupId,
  aureliaEnhance,
  preEnhance,
  afterEnhance,
  afterStart: callback => addStartHook(callback),
  changeVisibility: value => {
    instance(EventAggregator).publish(new UserVisibilityChangedEvent(value));
  },
  changeProfileImg: value => {
    instance(EventAggregator).publish(new ProfileImgChangedEvent(value));
  },
  get authService() {
    return instance(AuthService);
  },
  get currentGroup() {
    return instance(CurrentGroup);
  },
  get groupService() {
    return instance(GroupService);
  },
  get userDetails() {
    return instance(UserDetails);
  },
  get taskQueue() {
    return instance(TaskQueue);
  },
  get billingService() {
    return instance(BillingService);
  }
};

export class UserVisibilityChangedEvent extends Event {
  value?: boolean;

  constructor(value = PLATFORM.global.userInvisible) {
    super();
    this.value = value;
  }
}

export class ProfileImgChangedEvent extends Event {
  imgDeleted?: boolean;
  
  constructor(value) {
    super();
    this.imgDeleted = !value;
  }
}
